<template>
  <section>
    <v-card-text>
      <div class="text-center my-5">
        <h1>{{ this.percent }}%</h1>
      </div>
      <div class="text-center my-2">
        <h4>{{ score }} acerto(s) de {{ totalQuestions }} possíveis</h4>
      </div>
      <div class="text-center my-2">
        <v-rating
          v-model="rating"
          color="yellow darken-3"
          background-color="grey darken-1"
          empty-icon="$vuetify.icons.ratingFull"
          half-increments
          hover
          readonly
        ></v-rating>

        <div class="text-center mt-4 mb-4">
          <v-btn
            v-for="mockLog in logs"
            :key="mockLog.mock"
            text
            @click="reviewMock(mockLog.mock_log_id)"
            class="mr-4 primary"
          >
            Revisar {{ mockLog.mock }}
            <v-icon right dark>video_library</v-icon>
          </v-btn>
        </div>

        <v-card>
          <v-card-text>
            <v-simple-table>
              <template>
                <thead>
                  <tr>
                    <th class="text-left">Módulo</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Score</th>
                    <th class="text-center">Questões Certas</th>
                    <th class="text-center">Questões Erradas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="module in modules" :key="module.module_number">
                    <td class="text-left">Módulo {{ module.module_number }}</td>
                    <td>
                      <v-chip
                        v-if="getStatus(module.result_status) == 'Reprovado'"
                        color="red"
                        text-color="white"
                      >
                        {{ getStatus(module.result_status) }}
                      </v-chip>

                      <v-chip v-else color="green" text-color="white">
                        {{ getStatus(module.result_status) }}
                      </v-chip>
                    </td>
                    <td>{{ module.score }}%</td>
                    <td>{{ module.right_answers }}</td>
                    <td>{{ module.wrong_answers }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </div>
    </v-card-text>
  </section>
</template>

<script>
import PerformanceResultChart from "../widgets/chart/PerformanceResultChart";

export default {
  components: { PerformanceResultChart },
  data() {
    return {
      dialog: true,
      status: {
        1: "Aprovado",
        2: "Reprovado",
        3: "Aprovado",
      },
    };
  },
  computed: {
    rating() {
      return (this.percent / 100) * 5;
    },
    percent() {
      if (this.score === 0) return 0;
      return Math.round((this.score / this.totalQuestions) * 100);
    },
    ctaResult() {
      if (this.score === 0) return "Resultado";
      return "Resultado (" + this.percent + "%)";
    },
  },
  props: {
    totalQuestions: null,
    score: null,
    modules: null,
    disabled: true,
    type: null,
    logs: null,
  },
  methods: {
    isCorrect(option) {
      if (this.disabled && this.question.correct_answer) {
        return this.question.correct_answer === option;
      }
    },
    getStatus(status) {
      if (status == 1) {
        return "Aprovado";
      } else if (status == 3 && this.type == 1 && this.percent >= 70) {
        return "Aprovado";
      } else {
        return "Reprovado";
      }
    },
    reviewMock(mockLogId) {
      window.location = "/mocks/continue?mockLogId=" + mockLogId;
    },
  },
};
</script>

<style scoped>
.v-card__text {
  line-height: auto;
}

.text-center {
  text-align: center;
}

.correct {
  border-style: dotted;
  color: green;
  border-color: green;
  padding: 5px;
}

.statement {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
